import React, { useContext, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import EditForm from "./components/EditForm";
import { OwnedBusinessEntitiesEditProps } from "./lib/types";
import { useEditForm } from "./lib/useEditForm";
import { FlipperContext } from "../../../shared/lib/FlipperContext";
import { createUnifiedFile } from "../../../shared/lib/UnifiedFile";

const OwnedBusinessEntitiesEdit = (props: OwnedBusinessEntitiesEditProps) => {
  const flipper = useContext(FlipperContext);

  const designedArchitecturalWorksImages =
    flipper.disable_draft_feature && props.draftContent
      ? (props.draftContent.contractor_info_attributes?.architectural_design_works_attributes.map(
          (architecturalDesignWork) =>
            architecturalDesignWork.images.map((image) =>
              createUnifiedFile(image),
            ),
        ) ?? [[]])
      : (props.ownedBusinessEntity.contractor_info_attributes?.architectural_design_works_attributes?.map(
          (work) =>
            work.images.map((image) =>
              createUnifiedFile({ ...image, name: "", is_image: true }),
            ) ?? [],
        ) ?? [[]]);

  const methods = useEditForm({
    defaultValues: props.ownedBusinessEntity,
    applicationing: props.applicationing,
  });

  useEffect(() => {
    if (flipper.disable_draft_feature && props.draftContent) {
      methods.reset(props.draftContent, { keepDefaultValues: true })
    }
  }, [flipper.disable_draft_feature, methods, props.draftContent])

  return (
    <EditForm
      {...props}
      initialDesignedArchitecturalWorksImages={designedArchitecturalWorksImages}
      methods={methods}
    />
  );
};

const OwnedBusinessEntitiesEditWrapper = (
  props: OwnedBusinessEntitiesEditProps,
) => {
  return (
    <BrowserRouter>
      <OwnedBusinessEntitiesEdit {...props} />
    </BrowserRouter>
  );
};

export default OwnedBusinessEntitiesEditWrapper;
